import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { setAuthToken } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace("#", ""));
      const sessionId = params.get("session_id");

      if (!sessionId) {
        navigate("/auth", { replace: true });
        return;
      }

      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        const { user, token } = res.data;
        setAuthToken(token);
        localStorage.setItem("vita_user", JSON.stringify(user));
        navigate("/dashboard", { replace: true, state: { user } });
      } catch (err) {
        console.error("Auth callback error:", err);
        navigate("/auth", { replace: true });
      }
    };

    processSession();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 border-3 border-[#0B6E4F] border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-slate-500">Signing you in...</p>
      </div>
    </div>
  );
}
